<div class="groups-shops-create component-container component-page-container action-button-wrapper"
     fxLayout="column"
     fxLayoutGap="2%"
>
    <div class="bottom-action-mg groups-shops-create-form-container">
        <custom-panel header="Edytuj cechę" [areButtons]="false" class="flex flex-grow">
            <div panel-body *ngIf="!isLoading">
                <form [formGroup]="editingForm" (ngSubmit)="onSubmit()" fxLayout="row" fxLayoutGap="20px">
                    <mat-form-field fxFlex="auto">
                        <label>
                            <input matInput placeholder="Nazwa cechy" formControlName="name" required>
                        </label>
                    </mat-form-field>

                    <mat-form-field fxFlex="auto">
                        <mat-label>Rodzaj</mat-label>
                        <mat-select disabled formControlName="type">
                            <mat-option *ngFor="let type of types" [value]="type">
                                {{type}}
                            </mat-option>
                        </mat-select>
                    </mat-form-field>

                    <button #submitButton type="submit" style="display: none;"></button>
                </form>

                <div class="set-select-option" *ngIf="editingForm.get('type').value === 'Select'">
                    <p class="sim-step-hint pv-xs" fxLayout="row" fxLayoutAlign="flex-start center">
                        <mat-icon class="pr-xxs text-green">info</mat-icon>
                        <span class="upper text-green pr-xxs">podpowiedź:</span>
                        Dodaj opcje, które będą widoczne w polu typu Select
                    </p>
                    <div fxLayout="column">
                        <div class="select-field" *ngFor="let field of selectFields; let i = index" fxLayout="column">
                            <div fxFlex="auto">
                                <mat-form-field fxFlex="auto">
                                    <label>
                                        <input matInput placeholder="Wartość pola*" [(ngModel)]="field.name">
                                    </label>
                                </mat-form-field>
                                <div class="actions" fxFlex="none" fxLayout="row">
                                    <button mat-icon-button fxFlex="none" aria-label="Dodaj nowe pole" (click)="addField(i)">
                                        <mat-icon>add</mat-icon>
                                    </button>
                                    <button mat-icon-button fxFlex="none" aria-label="Skasuj pole" [disabled]="selectFields.length === 1" (click)="removeField(i)">
                                        <mat-icon>remove</mat-icon>
                                    </button>
                                </div>
                            </div>
                            <div class="mb-xs">
                                <div class="mat-error mat-small" *ngIf="field.name === ''" fxFlex="none" fxLayout="column">
                                    Wartość pola nie może być pusta
                                </div>
                                <div class="mat-error mat-small" *ngIf="fieldsIndexesErrors.includes(i)" fxFlex="none" fxLayout="column">
                                    Wartości pól nie mogą się powtarzać
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div panel-body class="text-center pb-s ml-s mt-xs" *ngIf="isLoading">
                <button-spinner [inProgress]="isLoading" diameter="100">
                </button-spinner>
            </div>
        </custom-panel>
    </div>
</div>

<div class="action-buttons">
    <div class="action-buttons-inner pv-xxxs" fxLayout="row"
         fxLayoutGap="1%" fxLayoutAlign="flex-end center"
    >
        <button-spinner class="ml-xxs" [inProgress]="isEditing" diameter="20">
        </button-spinner>
        <button
            type="button"
            class="upper action-button butt-back action-button-icon"
            (click)="navigationBack()"
        >
            <p class="upper">wróć</p>
            <mat-icon class="action-icon">keyboard_return</mat-icon>
        </button>
        <button (click)="onSubmit()"
                [disabled]="isEditing" class="upper action-button butt-primary action-button-icon">
            <p class="upper">zapisz</p>
            <mat-icon class="action-icon">save_alt</mat-icon>
        </button>
    </div>
</div>
